import { useEffect } from 'react';

function useMount(callback) {
  useEffect(function () {
    callback();
  }, []);
}

export { useMount };